import { KpiTableAndChart } from '@/types/KPI';
import { KpiGroupedApiResponse } from './types';

export type State = {
  kpiData: Array<KpiTableAndChart>;
  kpiDataIsLoading: boolean;
  groupedKpiData: Array<KpiGroupedApiResponse> | null;
  groupedKpiDataIsLoading: boolean;
};

export const state: State = {
  kpiData: [],
  kpiDataIsLoading: false,
  groupedKpiData: null,
  groupedKpiDataIsLoading: false,
};
